import { render } from "./About.vue?vue&type=template&id=939312f8&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=939312f8&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-939312f8"]])

export default __exports__